<div class="fechamento-comanda-page" *ngIf="comanda" style="max-width: 1300px;">
  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
        novalidate #frm="ngForm" (ngSubmit)="onSubmitFecharComanda($event)">

    <div class="fechamento-header">
      <div class="header-identificacao">
        <button class="btn-voltar" type="button" (click)="voltar()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div>
          <h1>Fechamento de Comanda</h1>
          <div class="header-meta">
            <span>Mesa {{comanda.mesa?.nome}}</span>
            <span *ngIf="comanda.codigoPdv">Comanda #{{comanda.codigoPdv}}</span>
            <span *ngIf="!comanda.codigoPdv">Comanda #{{comanda.id}}</span>
            <span>{{comanda.status}} às {{comanda.horarioAberturaDescricao}}</span>
          </div>
        </div>
      </div>

      <div class="header-acoes">
        <button type="button" class="btn btn-outline-secondary btn-garcom-topo"
                *ngIf="comanda.aberta || comanda.emFechamento"
                (click)="abraModalVincularGarcom()">
          <i class="fas fa-user-tie mr-1"></i>
          <span *ngIf="comanda.garcom?.nome">Garçom {{comanda.garcom.nome}}</span>
          <span *ngIf="!comanda.garcom?.nome">Informar Garçom</span>
        </button>

        <button type="button" class="btn btn-outline-primary btn-imprimir-topo"
                (click)="imprimirComanda($event)" [disabled]="imprimindo">
          <i class="fa fa-print mr-1"></i> Imprimir Comanda
        </button>
      </div>
    </div>

    <section class="fechamento-card pedidos-card">
      <div class="secao-titulo">
        <span class="secao-icone"><i class="fas fa-receipt"></i></span>
        <h2>Itens da Comanda</h2>
      </div>
      <app-grid-pedidos #gridPedidos [comanda]="comanda" [pedidos]="comanda.pedidos" [carregando]="carregando" [mesa]="true"
                        (onAtualizouComanda)="recarregueComanda($event)" [editarPedido]="true"></app-grid-pedidos>
    </section>


    <div class="fechamento-layout mt-2">
      <main class="fechamento-main">
        <section class="fechamento-card resumo-conta-card">
          <div class="secao-titulo">
            <span class="secao-icone"><i class="far fa-clipboard"></i></span>
            <h2>Resumo da Conta</h2>
          </div>

          <div class="linha-resumo">
            <span>Subtotal</span>
            <strong>{{comanda.valor | currency: 'BRL'}}</strong>
          </div>

          <div class="linha-resumo linha-taxa" *ngIf="exibeTaxaServico()">
            <span>Taxa de serviço ({{empresa.valorTaxaServico}}%)</span>
            <strong>{{comanda.taxaServico || 0 | currency: 'BRL'}}</strong>
          </div>

          <div class="linha-resumo linha-desconto" *ngIf="desconto > 0">
            <span>Desconto</span>
            <strong>- {{desconto | currency: 'BRL'}}</strong>
          </div>

          <div class="linha-total">
            <span>TOTAL A PAGAR</span>
            <strong>{{totalDaComanda() | currency: 'BRL'}}</strong>
          </div>

          <div class="controles-valores" [hidden]="comanda.fechada || comanda.emFechamento">
            <div class="controle-desconto">
              <p class="pay-section-kicker">Descontos e Benefícios</p>
              <div class="pd-main-row">
                <div class="pd-input-group">
                  <div class="pd-toggle-wrap">
                    <button type="button" class="pd-toggle" [class.is-active]="tipoDesconto === 'valor'"
                            (click)="tipoDesconto = 'valor'; recalculeTotalComanda()">R$</button>
                    <button type="button" class="pd-toggle" [class.is-active]="tipoDesconto === 'porcentagem'"
                            (click)="tipoDesconto = 'porcentagem'; recalculeTotalComanda()">%</button>
                  </div>
                  <kendo-numerictextbox name="valorDescontoInput"
                                        [format]="tipoDesconto === 'valor' ? 'c2' : obtenhaFormatoPercentual()"
                                        appRemovaWheel
                                        class="pd-input pd-input-discount"
                                        [disabled]="comanda.fechada || pixOnlineTunaPendente()"
                                        [(ngModel)]="valorDescontoInput"
                                        [min]="0"
                                        [max]="tipoDesconto === 'porcentagem' ? 100 : null"
                                        (ngModelChange)="recalculeTotalComanda()"
                                        placeholder="0,00">
                  </kendo-numerictextbox>
                </div>
              </div>
            </div>

            <label class="controle-taxa" *ngIf="empresa.cobrarTaxaServico">
              <input type="checkbox" class="k-checkbox" id="taxaServicoCheck"
                     name="taxaDeServico"
                     [disabled]="pixOnlineTunaPendente()"
                     (change)="alterouCobarTaxa()"
                     [(ngModel)]="comanda.cobrarTaxaServico">
              <span>Cobrar taxa de serviço ({{empresa.valorTaxaServico}}%)</span>
              <i class="fas fa-info-circle"></i>
            </label>
          </div>
        </section>

        <section class="fechamento-card pagamentos-realizados" *ngIf="comanda.pagamentos?.length > 0">
          <div class="secao-titulo">
            <span class="secao-icone"><i class="fas fa-wallet"></i></span>
            <h2>Pagamentos Realizados</h2>
          </div>

          <div class="pagamento-realizado-item" *ngFor="let pagamento of comanda.pagamentos">
            <div class="pagamento-realizado-info">
              <span class="icon-pagamento">
                <i class="fas fa-qrcode" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('pix')"></i>
                <i class="fas fa-money-bill-wave" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('dinheiro')"></i>
                <i class="fas fa-credit-card" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('crédito') || pagamento.formaDePagamento.nome?.toLowerCase().includes('credito')"></i>
                <i class="fas fa-id-card" *ngIf="pagamento.formaDePagamento.nome?.toLowerCase().includes('débito') || pagamento.formaDePagamento.nome?.toLowerCase().includes('debito')"></i>
                <i class="fas fa-wallet" *ngIf="!pagamento.formaDePagamento.nome?.toLowerCase().includes('pix') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('dinheiro') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('crédito') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('credito') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('débito') && !pagamento.formaDePagamento.nome?.toLowerCase().includes('debito')"></i>
              </span>
              <div>
                <strong>{{pagamento.formaDePagamento.descricao}}</strong>
                <div class="small text-muted mt-1" *ngIf="pagamento.taxa">
                  Taxa da forma de pagamento: {{pagamento.taxa | currency: 'BRL'}}
                </div>
                <div class="small mt-1" *ngIf="ehPagamentoPixOnlineTunaPendente(pagamento)">
                  <span class="badge badge-warning mr-1">Pendente</span>
                  <span class="text-muted" *ngIf="obtenhaDataExpiracaoPixOnline(pagamento)">
                    Expira em {{obtenhaDataExpiracaoPixOnline(pagamento) | date:'dd/MM/yyyy HH:mm'}}
                  </span>
                </div>
                <div class="pagamento-realizado-troco" *ngIf="pagamentoTemTroco(pagamento)">
                  <div>
                    <span>Recebido em dinheiro</span>
                    <strong>{{valorRecebidoTrocoPagamento(pagamento) | currency: 'BRL'}}</strong>
                  </div>
                  <div>
                    <span>Troco devolvido</span>
                    <strong>{{valorTrocoPagamento(pagamento) | currency: 'BRL'}}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="pagamento-realizado-valor">
              <span>Valor pago</span>
              <strong>{{pagamento.valor | currency: 'BRL'}}</strong>
              <button class="btn btn-sm btn-outline-primary mt-2" type="button"
                      *ngIf="ehPagamentoPixOnlineTunaPendente(pagamento)"
                      (click)="abraModalPixOnlineTuna(pagamento)">
                <i class="fas fa-qrcode mr-1"></i> Abrir QR Code
              </button>
              <button class="btn btn-sm btn-outline-secondary mt-2 ml-2" type="button"
                      *ngIf="ehPagamentoPixOnlineTunaPendente(pagamento)"
                      (click)="sincronizePixOnlineTuna(pagamento, true)"
                      [disabled]="sincronizandoPixOnlineTuna">
                <i class="k-icon k-i-loading mr-1" *ngIf="sincronizandoPixOnlineTuna"></i>
                <i class="fas fa-sync-alt mr-1" *ngIf="!sincronizandoPixOnlineTuna"></i>
                Sincronizar pagamento
              </button>
              <button class="btn btn-sm btn-success mt-2 ml-2" type="button"
                      *ngIf="ehPagamentoPixOnlineTunaPendente(pagamento)"
                      (click)="jaPagouPixOnlineTuna(pagamento)"
                      [disabled]="sincronizandoPixOnlineTuna">
                <i class="k-icon k-i-loading mr-1" *ngIf="sincronizandoPixOnlineTuna"></i>
                Já pagou
              </button>
            </div>
          </div>
        </section>

        <section #pagamentoCard class="fechamento-card pagamento-card"
                 *ngIf="(comanda.aberta || comanda.emFechamento) && comanda.valor && !exibirPrefechamento && !pixOnlineTunaPendente()">
          <h4 *ngIf="comanda.emFechamento" class="mb-2">Comanda em <b>Pré fechamento</b></h4>
          <i class="k-icon k-i-loading mt-2" *ngIf="carregandoFormasPagamentos"></i>

          <app-pagamento-comanda-metodo #gridPagamentos
                                        *ngIf="!carregandoFormasPagamentos"
                                        [frm]="frm"
                                        [pagamentoComanda]="true"
                                        [formasDePagamento]="formasPagamentoMesa"
                                        [totalPagar]="totalDaComanda()"
                                        [pixOnlineTunaForma]="formaPixOnlineTuna"
                                        [pixOnlineTunaGerado]="pagamentoPixOnline"
                                        (gerarPixOnlineTuna)="abraModalPixOnlineTuna()">
          </app-pagamento-comanda-metodo>
        </section>


        <section class="alerta-importante">
          <span><i class="fas fa-info-circle"></i></span>
          <div>
            <strong>Importante</strong>
            <p *ngIf="!gridPagamentos?.multiplasFormasPagamentos">Após fechar a comanda, não será possível adicionar itens.</p>
            <p *ngIf="gridPagamentos?.multiplasFormasPagamentos">A soma dos pagamentos deve ser igual ao total da comanda.</p>

          </div>
        </section>

        <section class="pontos-receber" *ngIf="comanda?.pontosReceber">
          <i class="fe-star-on text-blue"></i>
          Pontuação Receber: <b>{{comanda.pontosReceber}}</b>
        </section>

      </main>

      <aside class="fechamento-resumo-lateral">
        <div class="resumo-lateral-card">
          <span class="resumo-label">Total a Pagar</span>
          <strong class="resumo-total">{{totalDaComanda() | currency: 'BRL'}}</strong>
          <p>Confira os valores e finalize o pagamento.</p>

          <div class="resumo-lateral-linhas">
            <div>
              <span><i class="far fa-clipboard mr-2"></i>Subtotal</span>
              <strong>{{comanda.valor | currency: 'BRL'}}</strong>
            </div>
            <div class="linha-taxa" *ngIf="exibeTaxaServico()">
              <span><i class="fas fa-tag mr-2"></i>Taxa de serviço ({{empresa.valorTaxaServico}}%)</span>
              <strong>{{comanda.taxaServico || 0 | currency: 'BRL'}}</strong>
            </div>
            <div class="linha-desconto" *ngIf="desconto > 0">
              <span><i class="fas fa-tag mr-2"></i>Desconto</span>
              <strong>- {{desconto | currency: 'BRL'}}</strong>
            </div>
          </div>

          <div class="resumo-lateral-total">
            <span>TOTAL</span>
            <strong>{{totalDaComanda() | currency: 'BRL'}}</strong>
          </div>

          <div class="resumo-pagamento-fechamento" *ngIf="exibeResumoPagamentoFechamento()">
            <div class="resumo-pagamento-titulo">
              <span><i class="fas fa-wallet mr-2"></i>Pagamento</span>
              <strong>{{tituloResumoPagamentoFechamento()}}</strong>
            </div>

            <ng-container *ngIf="pagamentosResumoFechamento() as pagamentosResumo">
              <div class="resumo-pagamento-vazio" *ngIf="!pagamentosResumo.length">
                Selecione a forma de pagamento para fechar a comanda.

                <button class="btn-selecionar-pagamento-mobile" type="button"
                        *ngIf="isMobile && exibeBotaoSelecionarPagamentoMobile()"
                        (click)="roleParaPagamento()">
                  Selecionar pagamento
                </button>
              </div>



              <div class="resumo-pagamento-item" *ngFor="let pagamento of pagamentosResumo">
                <span class="resumo-pagamento-icone">
                  <i [class]="iconeResumoPagamento(pagamento)"></i>
                </span>
                <div class="resumo-pagamento-info">
                  <strong>{{descricaoResumoPagamento(pagamento)}}</strong>
                  <small *ngIf="trocoResumoPagamento(pagamento) > 0">
                    Recebido {{valorRecebidoResumoPagamento(pagamento) | currency: 'BRL'}}
                    <span>|</span>
                    Troco {{trocoResumoPagamento(pagamento) | currency: 'BRL'}}
                  </small>
                </div>
                <span class="resumo-pagamento-valor">{{pagamento.valor | currency: 'BRL'}}</span>
              </div>

              <div class="resumo-pagamento-diferenca linha-desconto" *ngIf="totalDescontoResumoPagamento() > 0">
                <span>Desconto forma de pagamento</span>
                <strong>- {{totalDescontoResumoPagamento() | currency: 'BRL'}}</strong>
              </div>

              <div class="resumo-pagamento-diferenca linha-taxa-forma-pagamento" *ngIf="totalTaxaResumoPagamento() > 0">
                <span>Taxa forma de pagamento</span>
                <strong>{{totalTaxaResumoPagamento() | currency: 'BRL'}}</strong>
              </div>

              <div class="resumo-pagamento-diferenca" *ngIf="diferencaResumoPagamento() !== 0">
                <span>Diferença</span>
                <strong [class.text-danger]="diferencaResumoPagamento() !== 0">
                  {{diferencaResumoPagamento() | currency: 'BRL'}}
                </strong>
              </div>
            </ng-container>
          </div>

          <div class="resumo-pix-online-gerar" *ngIf="pixOnlineTunaSelecionadoParaGerar()">
            <div>
              <strong>Pix Online selecionado</strong>
              <small>Gere o QR Code antes de fechar a comanda.</small>
              <small>QR Code será gerado agora.</small>
            </div>
            <button class="btn btn-outline-primary btn-block" type="button" (click)="abraModalPixOnlineTuna()">
              <i class="fas fa-qrcode mr-1"></i> Gerar Pix
            </button>
          </div>

          <div *ngIf="erro" class="erro-fechamento-lateral" role="alert" [class.erro-entrada]="erroAnimando">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{erro}}</span>
          </div>

          <section class="opcoes-parceiro mb-2" *ngIf="comanda.fecharNoParceiro" [hidden]="!comanda.aberta && !comanda.emFechamento">
            <label>
              <input name="fecharNoParceiro" id="fecharNoParceiro" class="k-checkbox" kendoCheckBox
                     type="checkbox" [(ngModel)]="fecharSomenteMeucardapio" (change)="alterouFecharParceiro()" />
              <span>Fechar somente no <b>Meucadapio</b> e ignorar fechamento no parceiro <b>{{empresa.integracaoDelivery?.sistema}}</b></span>
            </label>
          </section>

          <button class="btn btn-success btn-acao-principal"
                  type="button"
                  (click)="enviePreFechamento()"
                  [disabled]="fechando || pixOnlineTunaPendente()"
                  *ngIf="exibirPrefechamento && !fecharSemPrechamento">
            <span *ngIf="fechando" class="loading-spinner"></span>
            <i class="fas fa-lock mr-1" *ngIf="!fechando"></i>
            Pré Fechamento
          </button>

          <button class="btn btn-success btn-fechar-comanda btn-acao-principal"
                  [disabled]="fechando || bloqueiaFecharPorPixOnline()"
                  [hidden]="operador.garcom && !empresa.garcomFecharComandas"
                  *ngIf="(comanda.aberta || comanda.emFechamento) && (!exibirPrefechamento || fecharSemPrechamento) && (!comanda.preFechamentoObrigatorio || comanda.emFechamento || fecharSomenteMeucardapio)">
            <span *ngIf="fechando" class="loading-spinner"></span>
            <i class="fas fa-lock mr-1" *ngIf="!fechando"></i>
            Fechar Comanda

          </button>

          <button class="btn btn-success btn-block mt-2 btn-acao-principal" type="button"
                  *ngIf="podeEmitirNfceDaComanda()"
                  [disabled]="comanda.atualizando"
                  (click)="emitirNfceDaComanda($event)">
            <i class="fas fa-file-invoice-dollar mr-1" *ngIf="!comanda.atualizando"></i>
            Emitir NFC-e <i class="k-i-loading k-icon" *ngIf="comanda.atualizando"></i>
          </button>

          <button class="btn btn-outline-secondary btn-block mt-2" type="button" [hidden]="fecharSomenteMeucardapio"
                  (click)="cancelarFecharDireto()" *ngIf="fecharSemPrechamento" [disabled]="fechando">
            Voltar
          </button>

          <button class="btn btn-outline-primary btn-block mt-3 btn-acao-lateral" type="button" (click)="novoPedidoComanda()"
                  [disabled]="fechando || pixOnlineTunaPendente()"
                  *ngIf="(comanda.aberta || comanda.emFechamento) && !fecharSemPrechamento">
            <i class="fas fa-plus mr-1"></i> Novo Pedido
          </button>


          <button type="button" class="btn btn-outline-primary btn-block mt-2 btn-acao-lateral"
                  *ngIf="(!configImpressao || !configImpressao.multiplasImpressoras) && configImpressao?.layoutPedido !== 'Ambos'"
                  (click)="imprimirComanda($event)" [disabled]="imprimindo">
            <i class="fa fa-print mr-1"></i> Imprimir Comanda
          </button>

          <button class="btn btn-outline-primary btn-block mt-2 btn-acao-lateral" type="button" (click)="trocaMesa()"
                  [disabled]="fechando || pixOnlineTunaPendente()"
                  *ngIf="(comanda.aberta || comanda.emFechamento) && !fecharSemPrechamento">
            <i class="fas fa-exchange-alt mr-1"></i> Trocar Mesa
          </button>


          <kendo-dropdownbutton *ngIf="(!configImpressao || !configImpressao.multiplasImpressoras) && configImpressao?.layoutPedido === 'Ambos'"
                                class="btn-block mt-2 dropdown-acao-lateral"
                                [data]="opcoesImpressao"
                                [popupSettings]="{animate: true, appendTo: 'component', popupClass: 'impressao-dropdown-popup'}"
                                (itemClick)="imprimirComanda($event)"
                                [disabled]="imprimindo">
            <i class="fa fa-print mr-1"></i> Imprimir Comanda
            <ng-template kendoDropDownButtonItemTemplate let-dataItem>
              <div class="impressao-dropdown-item">
                <span class="impressao-dropdown-icon"><i class="fa fa-print"></i></span>
                <span class="impressao-dropdown-text">
                  <strong>{{dataItem}}</strong>
                  <small>Layout da comanda</small>
                </span>
              </div>
            </ng-template>
          </kendo-dropdownbutton>

          <kendo-dropdownbutton *ngIf="configImpressao?.multiplasImpressoras && impressoras.length"
                                class="btn-block mt-2 dropdown-acao-lateral"
                                [data]="impressoras"
                                [popupSettings]="{animate: true, appendTo: 'component', popupClass: 'impressao-dropdown-popup'}"
                                (itemClick)="imprimirComanda($event, true)"
                                [textField]="'setor'">
            <i class="fa fa-print mr-1"></i> Imprimir Comanda
            <ng-template kendoDropDownButtonItemTemplate let-dataItem>
              <div class="impressao-dropdown-item">
                <span class="impressao-dropdown-icon"><i class="fa fa-print"></i></span>
                <span class="impressao-dropdown-text">
                  <strong>{{dataItem?.setor || dataItem?.nome || 'Impressora'}}</strong>
                  <small>{{dataItem?.layout || 'Layout padrão'}}</small>
                </span>
              </div>
            </ng-template>
          </kendo-dropdownbutton>
        </div>
      </aside>
    </div>
  </form>
</div>

<div class="alert alert-danger alert-dismissible fade show" *ngIf="carregou && comanda && !comanda.id" role="alert">
  <p>Comanda não encontrada</p>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="sucesso-fechamento" *ngIf="sucessoFechamento">
  <i class="fas fa-check-circle mr-2"></i>
  Comanda fechada com sucesso!
</div>

<kendo-dialog class="pix-online-tuna-dialog"
              title="Gerar QR Code Pix"
              *ngIf="exibirPixOnlineTuna"
              (close)="fecheModalPixOnlineTuna()"
              [minWidth]="isMobile ? 280 : 320"
              [width]="isMobile ? 'calc(100vw - 16px)' : (pagamentoPixOnline ? 430 : 720)">
  <div class="pix-online-tuna-modal">
    <div class="pix-online-tuna-erro" *ngIf="erroPixOnlineTuna">
      <i class="fas fa-exclamation-circle mr-1"></i>
      {{erroPixOnlineTuna}}
    </div>



    <ng-container *ngIf="!pagamentoPixOnline">
      <div class="pix-online-tuna-hero">
        <span><i class="fas fa-qrcode"></i></span>
        <div>
          <h3>Gerar QR Code Pix</h3>
          <p>Gere um QR Code para o cliente realizar o pagamento.</p>
        </div>
      </div>

      <div class="pix-online-tuna-section">
        <div class="pix-online-section-title">
          <span><i class="far fa-address-card"></i></span>
          <div>
            <strong>Dados do cliente</strong>
            <small>Nome obrigatório, e-mail e telefone opcionais.</small>
          </div>
        </div>

        <div class="pix-online-form-grid">
          <label>
            <span>Nome</span>
            <div class="pix-online-input"
                 [class.invalido]="nomePixOnlineInvalido() && tentouGerarPixOnlineTuna">
              <i class="far fa-user"></i>
              <input #pixClienteNomeInput
                     name="pixClienteNome"
                     placeholder="Digite o nome do cliente"
                     [(ngModel)]="dadosClientePixOnline.nome"
                     [ngModelOptions]="{standalone: true}">
            </div>
            <small class="pix-online-campo-erro"
                   *ngIf="nomePixOnlineInvalido() && tentouGerarPixOnlineTuna">
              Nome obrigatório.
            </small>
          </label>

          <label>
            <span>E-mail</span>
            <div class="pix-online-input"
                 [class.invalido]="emailPixOnlineInvalido() && (dadosClientePixOnline.email || tentouGerarPixOnlineTuna)">
              <i class="far fa-envelope"></i>
              <input name="pixClienteEmail"
                     type="email"
                     placeholder="ex.: cliente@exemplo.com"
                     [(ngModel)]="dadosClientePixOnline.email"
                     [ngModelOptions]="{standalone: true}"
                     email>
            </div>
            <small class="pix-online-campo-erro"
                   *ngIf="emailPixOnlineInvalido() && (dadosClientePixOnline.email || tentouGerarPixOnlineTuna)">
              E-mail inválido.
            </small>
          </label>

          <label class="pix-online-form-full">
            <span>Telefone / WhatsApp</span>
            <div class="pix-online-input"
                 [class.invalido]="telefonePixOnlineInvalido() && (dadosClientePixOnline.telefone || tentouGerarPixOnlineTuna)">
              <i class="fas fa-phone-volume"></i>
              <input name="pixClienteTelefone"
                     placeholder="(xx) 9 9999-9999"
                     [(ngModel)]="dadosClientePixOnline.telefone"
                     [ngModelOptions]="{standalone: true}"
                     mask="(00) 00000-0000"
                     [validation]="false">
            </div>
            <small class="pix-online-campo-erro"
                   *ngIf="telefonePixOnlineInvalido() && (dadosClientePixOnline.telefone || tentouGerarPixOnlineTuna)">
              Telefone inválido. Informe DDD e número, ex.: 62981000001.
            </small>
          </label>
        </div>

        <!--<div class="pix-online-tuna-note">
          <i class="fas fa-info-circle"></i>
          <span>Esses dados serão exibidos no comprovante do pagamento.</span>
        </div> -->
      </div>

      <div class="pix-online-valor-card">
        <span><i class="fas fa-qrcode"></i></span>
        <div>
          <strong><span class="k-text-uppercase font-18">Mesa {{comanda.mesa?.nome}} - Comanda #{{comanda.id}}</span></strong>
          <small>Este é o valor que o cliente irá pagar via Pix.</small>
        </div>
        <strong>{{totalDaComanda() | currency:'BRL'}}</strong>
      </div>

      <div class="pix-online-tuna-section pix-online-info-section">
        <div class="pix-online-section-title">
          <span><i class="fas fa-shield-alt"></i></span>
          <div>
            <strong>Informações importantes</strong>
          </div>
        </div>
        <ul>
          <li><i class="fas fa-check"></i> O QR Code expira em 10 minutos.</li>
          <li><i class="fas fa-check"></i> Após o pagamento, a confirmação é automática.</li>
          <li><i class="fas fa-check"></i> O cliente pode pagar com qualquer app do banco.</li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="pagamentoPixOnline">
      <div class="pix-online-gerado-card" *ngIf="pagamentoPixOnline.codigoQrCode">
        <h3>QR Code Pix</h3>
        <p>Escaneie o QR Code para pagar</p>
        <strong class="pix-online-gerado-valor">{{(pagamentoPixOnline.valor || totalDaComanda()) | currency:'BRL'}}</strong>

        <img class="pix-online-tuna-qrcode"
           [src]="obtenhaUrlQrCodePixOnline()"
           alt="QR Code Pix">

        <div class="pix-online-copia">
          <label>Copia e Cola (Pix Copia e Cola)</label>
          <div>
            <input readonly [value]="pagamentoPixOnline.codigoQrCode">
            <button class="btn" type="button" (click)="copiePixOnline()" title="Copiar código Pix">
              <i class="far fa-copy"></i>
            </button>
          </div>
          <small *ngIf="mensagemPixCopiado">{{mensagemPixCopiado}}</small>
        </div>

        <div class="pix-online-tuna-contador" *ngIf="pixOnlineTunaTempoRestante">
          <span><i class="far fa-clock"></i> Expira em</span>
          <strong [class.text-danger]="pixOnlineTunaExpirado">{{pixOnlineTunaTempoRestante}}</strong>
          <span class="badge badge-danger" *ngIf="pixOnlineTunaExpirado">Expirado</span>
        </div>

        <div class="pix-online-dica">
          <i class="far fa-lightbulb"></i>
          <div>
            <strong>Dica para o cliente</strong>
            <small>Abra o app do seu banco, escolha Pix e escaneie o QR Code ou copie o código.</small>
          </div>
        </div>
      </div>

      <div class="pix-online-tuna-note" *ngIf="!pagamentoPixOnline.codigoQrCode">
        <i class="fas fa-info-circle"></i>
        Pix pendente gerado. Cancele o Pix para liberar a comanda.
      </div>
    </ng-container>
  </div>

  <kendo-dialog-actions class="pix-online-tuna-actions">
    <button class="btn btn-outline-secondary" type="button"
            *ngIf="!confirmandoCancelamentoPixOnlineTuna"
            (click)="fecheModalPixOnlineTuna()">
      Fechar
    </button>
    <button class="btn btn-success" type="button"
            *ngIf="!pagamentoPixOnline"
            (click)="gerePixOnlineTuna()"
            [disabled]="gerandoPixOnlineTuna">
      <i class="k-icon k-i-loading mr-1" *ngIf="gerandoPixOnlineTuna"></i>
      Gerar QR Code Pix
    </button>
    <button class="btn btn-danger" type="button"
            *ngIf="pagamentoPixOnline && !confirmandoCancelamentoPixOnlineTuna"
            (click)="soliciteCancelamentoPixOnlineTuna()"
            [disabled]="cancelandoPixOnlineTuna">
      <i class="k-icon k-i-loading mr-1" *ngIf="cancelandoPixOnlineTuna"></i>
      Cancelar Pix
    </button>
    <button class="btn btn-outline-primary" type="button"
            *ngIf="pagamentoPixOnline && !confirmandoCancelamentoPixOnlineTuna"
            (click)="sincronizePixOnlineTuna(pagamentoPixOnline, true)"
            [disabled]="sincronizandoPixOnlineTuna || cancelandoPixOnlineTuna">
      <i class="k-icon k-i-loading mr-1" *ngIf="sincronizandoPixOnlineTuna"></i>
      <i class="fas fa-sync-alt mr-1" *ngIf="!sincronizandoPixOnlineTuna"></i>
      Sincronizar pagamento
    </button>
    <button class="btn btn-success" type="button"
            *ngIf="pagamentoPixOnline && !confirmandoCancelamentoPixOnlineTuna"
            (click)="jaPagouPixOnlineTuna(pagamentoPixOnline)"
            [disabled]="sincronizandoPixOnlineTuna || cancelandoPixOnlineTuna">
      <i class="k-icon k-i-loading mr-1" *ngIf="sincronizandoPixOnlineTuna"></i>
      Já pagou
    </button>
    <div class="pix-online-confirmacao-cancelamento" *ngIf="pagamentoPixOnline && confirmandoCancelamentoPixOnlineTuna">
      <span>Cancelar o Pix gerado e liberar a comanda?</span>
      <button class="btn btn-outline-secondary" type="button"
              (click)="volteCancelamentoPixOnlineTuna()"
              [disabled]="cancelandoPixOnlineTuna">
        Voltar
      </button>
      <button class="btn btn-danger" type="button"
              (click)="cancelePixOnlineTuna()"
              [disabled]="cancelandoPixOnlineTuna">
        <i class="k-icon k-i-loading mr-1" *ngIf="cancelandoPixOnlineTuna"></i>
        Confirmar
      </button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
